import { useEffect, useState } from "react";

type NavigatorWithConnection = Navigator & {
  connection?: {
    effectiveType?: string;
    downlink?: number;
    rtt?: number;
  };
};

export const useOnlineStatus = () => {
  const [online, setOnline] = useState(window.navigator.onLine);
  const [weakConnection, setWeakConnection] = useState(false);

  const getWeakConnection = () => {
    const connection = (navigator as NavigatorWithConnection).connection;

    if (!navigator.onLine) {
      return true;
    }

    return (
      connection?.effectiveType === 'slow-2g' ||
      connection?.effectiveType === '2g' ||
      connection?.effectiveType === '3g' ||
      (connection?.rtt ?? 0) >= 500 ||
      (connection?.downlink ?? Infinity) <= 1
    );
  };

  useEffect(() => {
    window.setInterval(() => setWeakConnection(getWeakConnection()), 1000 * 5);

    window.addEventListener("online", () => setOnline(true));
    window.addEventListener("offline", () => setOnline(false));
  }, []);

  return {online, weakConnection} ;
};
